import clsx from 'clsx';

import { Box, type BoxProps } from '../Box';

import { cardVariants } from './cardVariants';
import { CardHeader } from './Header';

import type { CardVariants } from './types';

export type CardProps = CardVariants & Omit<BoxProps, 'background'>;

export const Card = ({ background, children, className, ...props }: CardProps) => (
  <Box className={clsx(cardVariants({ background, className }), className)} {...props}>
    {children}
  </Box>
);

Card.Header = CardHeader;
